import { render, staticRenderFns } from "./CheckoutDeliverItem.vue?vue&type=template&id=60fbeeb3&"
import script from "./CheckoutDeliverItem.vue?vue&type=script&lang=js&"
export * from "./CheckoutDeliverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports